
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  computed: {
    category() {
      return this.page.entry.product_categories[0] ?? null
    },
  },
}
